import styled from 'styled-components';

export const Div = styled.div`
    width:600px;
    height: 500px;
    @media (max-width: 960px) {
        width:400px;
    height: 300px;
    }
`